module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (availableProducts && availableProducts.cfe_demo) { ;
__p += '\n  <div id="resourceContainer" class="resourceContainer">\n    <div id="CfeDemoBar" class="resourceTitleBar">\n      <div class="resourceContainerLabel"><span>' +
((__t = ( i18n.computeResourcePageCfeDemoLabel )) == null ? '' : __t) +
'</span></div>\n      <div class="dropdown menu-container createNewComputeResource">\n        <button id="startNewCfeDemoButton" type="button" disabled="disabled" class="disabled btn startNewMatlabButton" title="' +
((__t = ( i18n.createCfeDemoButtonTooltip )) == null ? '' : __t) +
'" aria-haspopup="true" aria-expanded="false">\n          <span class="icon-add"></span>\n          <span>' +
((__t = ( i18n.computeResourcePageCreateNewCfeDemoLabel )) == null ? '' : __t) +
'</span>\n        </button>\n      </div>\n    </div>\n    <div class="noCfeDemoMessageContainer" style="display: none;">\n      <div class="noDataMsg"><span>' +
((__t = ( i18n.computeResourcePageNoCfeDemosFound )) == null ? '' : __t) +
'</span></div>\n    </div>\n    <div class="cfeDemoContainer">\n      <section>\n        <ol id="cfe_demo-resource-collection" class="collection collection-container">\n          <div class="progressSpinnerContainer">\n            <mw-progress-indicator type="spinner" size="small"></mw-progress-indicator>\n          </div>\n        </ol>\n      </section>\n    </div>\n  </div>\n';
 } ;
__p += '\n';

}
return __p
};
